<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN" id="_idParaDest-5"><a id="_idTextAnchor000"></a>CONTENTS</p>
<p class="Con-CT ParaOverride-5"><a href="#/97808021888095#_idTextAnchor001">Prologue</a></p>
<p class="Con-CT"><a href="#/97808021888096#_idTextAnchor002">Introduction</a>: A Prelude to Gravity</p>
<p class="Con-PT"><a href="#/97808021888097#_idTextAnchor003">THE BACK SEAT</a></p>
<p class="Con-CT"><a href="#/97808021888098#_idTextAnchor004">Chapter</a> 1: What Were the Skies like When You Were Little</p>
<p class="Con-CT"><a href="#/97808021888099#_idTextAnchor005">Chapter</a> 2: Juke Box Fury</p>
<p class="Con-CT"><a href="#/978080218880910#_idTextAnchor007">Chapter</a> 3: On Saturday Afternoons in 1963</p>
<p class="Con-CT"><a href="#/978080218880911#_idTextAnchor008">Chapter</a> 4: A Summer Song</p>
<p class="Con-CT"><a href="#/978080218880912#_idTextAnchor009">Chapter</a> 5: The Winston Lips of September</p>
<p class="Con-PT"><a href="#/978080218880913#_idTextAnchor013">RIDING SHOTGUN</a></p>
<p class="Con-CT"><a href="#/978080218880914#_idTextAnchor014">Chapter</a> 6: The Moon Is Made of Gold</p>
<p class="Con-CT"><a href="#/978080218880915#_idTextAnchor015">Chapter</a> 7: Gravity</p>
<p class="Con-CT"><a href="#/978080218880916#_idTextAnchor017">Chapter</a> 8: You Never Know When You’re Making a Memory</p>
<p class="Con-CT"><a href="#/978080218880917#_idTextAnchor019">Chapter</a> 9: The Summer of 1969</p>
<p class="Con-CT"><a href="#/978080218880918#_idTextAnchor020">Chapter</a> 10: Walk on Guilded Splinters</p>
<p class="Con-CT"><a href="#/978080218880919#_idTextAnchor023">Chapter</a> 11: Olympia</p>
<p class="Con-CT"><a href="#/978080218880920#_idTextAnchor024">Chapter</a> 12: Surfer Girl on the Waterbed</p>
<p class="Con-CT"><a href="#/978080218880921#_idTextAnchor027">Chapter</a> 13: Turn Her Over and Go . . .</p>
<p class="Con-CT"><a href="#/978080218880922#_idTextAnchor028">Chapter</a> 14: Doyt-Doyt—Venice Beach</p>
<p class="Con-PT"><a href="#/978080218880923#_idTextAnchor029">DRIVER’S SEAT</a></p>
<p class="Con-CT"><a href="#/978080218880924#_idTextAnchor030">Chapter</a> 15: Easy Money</p>
<p class="Con-CT"><a href="#/978080218880925#_idTextAnchor031">Chapter</a> 16: Young Blood</p>
<p class="Con-CT"><a href="#/978080218880926#_idTextAnchor032">Chapter</a> 17: The Man with the Star</p>
<p class="Con-CT"><a href="#/978080218880927#_idTextAnchor036">Chapter</a> 18: Rickie Lee Jones</p>
<p class="Con-PT"><a href="#/978080218880928#_idTextAnchor038">THE WAY BACK SEAT</a></p>
<p class="Con-CT"><a href="#/978080218880929#_idTextAnchor039">Chapter</a> 19: Saturday Night Live</p>
<p class="Con-CT"><a href="#/978080218880930#_idTextAnchor040">Chapter</a> 20: The Bus Stop Blues</p>
<p class="Con-CT"><a href="#/978080218880931#_idTextAnchor042">Chapter</a> 21: Jazz Side of Life</p>
<p class="Con-CT"><a href="#/978080218880932#_idTextAnchor043">Chapter</a> 22: It Must Be Love</p>
<p class="Con-CT ParaOverride-6"><a href="#/978080218880933#_idTextAnchor044">Epilogue</a></p>
<p class="Con-CT ParaOverride-6"><a href="#/978080218880934#_idTextAnchor045">Photo Insert</a></p>
<p class="Con-CT ParaOverride-6"><a href="#/978080218880935#_idTextAnchor046">Acknowledgments</a></p>
<p class="Con-CT ParaOverride-6"><a href="#/978080218880936#_idTextAnchor047">Glossary</a> of Songs</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802188809-4.vue?7b563ed8